import type { Component } from '@which/glide-ts-types'
import { InPageAnchorLink, Typography } from '@which/seatbelt'

import * as articlePageComponents from '../../pages/article/components'

type LocalComponent = keyof typeof localComponent
import * as localComponent from '../components'
import { Link } from '../components/Link'

export type ComponentMap = Record<Component | LocalComponent, unknown>
export const componentMap: ComponentMap = {
  ...localComponent,
  ...articlePageComponents,
  AcastPodcast: localComponent.IframeEmbed,
  StandardLink: Link,
  InPageAnchorLink,
  Typography,
  PICategoriesSection: localComponent.PICategories,
  PITopicsSection: localComponent.PITrendingTopicsSection,
  PILatestReleasesSection: undefined,
  PIHeader: localComponent.PIHeader,
  PISearchContent: localComponent.PISearchContent,
} as const
